export default __webpack_public_path__ + "static/media/ownDamageType.82e76985.svg";